import { useEffect } from 'react'

//* * useOnClickOutside hook from https://usehooks.com/ */
export const useOnClickOutside = (
  ref,
  handler: (event: MouseEvent | TouchEvent) => void
) =>
  useEffect(() => {
    const listener = (event) => {
      // Do nothing if clicking ref's element or descendent elements
      if (!ref.current || ref.current.contains(event.target)) {
        return
      }

      handler(event)
    }

    document.addEventListener('mousedown', listener)
    document.addEventListener('touchstart', listener)

    return () => {
      document.removeEventListener('mousedown', listener)
      document.removeEventListener('touchstart', listener)
    }
  }, [ref, handler]) // Add ref and handler to effect dependencies
